import { useEffect, useRef } from 'react';
import { useHomeStore } from '../model/homeStore';
import { useOnlineStatus } from './useOnlineStatus';
import type { HomeResponse } from '../model/types';

interface UseHomeDataResult {
  data: HomeResponse | null;
  isLoading: boolean;
  error: string | null;
  refresh: () => Promise<void>;
}

/**
 * Home sahifasi uchun asosiy data hook.
 * - Mount bo'lganda fetch (idempotent — store qayta fetch qilmaydi)
 * - Online bo'lganda 60s dan eski data'ni yangilaydi
 */
export function useHomeData(): UseHomeDataResult {
  const fetch = useHomeStore((s) => s.fetch);
  const refresh = useHomeStore((s) => s.refresh);
  const data = useHomeStore((s) => s.data);
  const status = useHomeStore((s) => s.status);
  const errorMessage = useHomeStore((s) => s.errorMessage);

  const { isOnline } = useOnlineStatus();
  const wasOfflineRef = useRef<boolean>(!navigator.onLine);

  // Mount bo'lganda fetch
  useEffect(() => {
    void fetch();
  }, [fetch]);

  // Offline → online bo'lganda yangilash
  useEffect(() => {
    if (isOnline && wasOfflineRef.current) {
      wasOfflineRef.current = false;
      void refresh();
    }
    if (!isOnline) {
      wasOfflineRef.current = true;
    }
  }, [isOnline, refresh]);

  // Til o'zgarganda qayta yuklash homeStore modulida singleton listener
  // sifatida amalga oshiriladi — bu komponent unmount bo'lganda ham ishlaydi.

  const isLoading = status === 'idle' || status === 'loading';

  return {
    data,
    isLoading,
    error: errorMessage,
    refresh,
  };
}
